import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 md:py-32 bg-[#0A0A0A] text-[#FAF7F2] relative overflow-hidden" data-id="element-79">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#B91C1C]/[0.08] blur-[100px] rounded-full pointer-events-none" data-id="element-80"></div>

      <div className="max-w-3xl mx-auto px-4 relative z-10 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-82">
          <div className="space-y-4 mb-10" data-id="element-83">
            <p className="text-2xl md:text-3xl font-serif text-[#FAF7F2]/80 font-light" data-id="element-84">
              Tu relación no necesita drama.
            </p>
            <p className="text-3xl md:text-4xl font-bold font-serif text-[#FAF7F2]" data-id="element-85">
              Necesita dirección.
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2]/70 font-light" data-id="element-86">
              Y la rutina no se va sola.
            </p>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C5A55A]/40 to-transparent mb-10" data-id="element-87"></div>

          {/* Price & details */}
          <div className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-88">
            <span className="text-5xl md:text-6xl font-bold font-serif text-[#FAF7F2]" data-id="element-89">
              $10
            </span>
            <div className="flex flex-col items-start text-left" data-id="element-90">
              <span className="text-[#C5A55A] text-sm uppercase tracking-widest" data-id="element-91">
                Acceso inmediato
              </span>
              <span className="text-[#FAF7F2]/60 text-sm" data-id="element-92">Clase grabada</span>
            </div>
          </div>

          <p className="text-lg text-[#FAF7F2]/60 mb-10" data-id="element-93">
            Puedes verla sola o en pareja.
          </p>

          {/* CTA Button */}
          <motion.a href="https://pay.hotmart.com/O104329024S?off=5fgsnhcn&checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center gap-3 bg-[#B91C1C] hover:bg-[#991b1b] text-white text-xl md:text-2xl font-bold py-6 px-12 rounded-sm shadow-[0_0_40px_rgba(185,28,28,0.5)] hover:shadow-[0_0_60px_rgba(185,28,28,0.7)] transition-all duration-300 group" data-id="element-94">
            QUIERO ENCENDER MI RELACIÓN AHORA
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-95" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}